export default [
  { value: "", text: "" },
  { value: "pain reliever", text: "Pain Reliever" },
  { value: "sedative", text: "Sedative" },
  { value: "stimulant", text: "Stimulant" },
  { value: "tranquilizer", text: "Tranquilizer" }
];
